<template>
    <v-dialog v-model="dialog" width="450px">
        <template v-slot:activator="{ on }">
            <span v-on="on">
                <slot></slot>
            </span>
        </template>
        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">{{messageText}}</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-switch
                            v-model="push_drivers"
                            label="Send push message to drivers"
                        ></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <div class="d-flex justify-center">
                            <v-btn
                                depressed
                                class="mr-4 primary"
                                @click="submit"
                            ><v-icon left>mdi-content-copy</v-icon>Confirm</v-btn>
                            <v-btn
                                class="warning"
                                depressed
                                @click="dialog=false"
                            ><v-icon left>mdi-cancel</v-icon>Cancel</v-btn>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        
    </v-dialog>
</template>

<script>

const NOTIFY_CHECKED = 10;
const NOTIFY_UNCHECKED = 20;

export default {
    name: "ConfirmDialog",
    props: ['messageText', 'pushDrivers'],
    data: () => ({
        dialog: false,
        push_drivers: true,
    }),

    created() {
        this.push_drivers = this.pushDrivers == NOTIFY_UNCHECKED ? false : true;
    },

    methods: {
        submit () {
            this.dialog = false;
            this.$emit('successClick', {
                'push_drivers': this.push_drivers ? NOTIFY_CHECKED : NOTIFY_UNCHECKED,
            })
        },
    },
}
</script>

<style scoped>

</style>